import React, {
  useRef, useEffect, useLayoutEffect, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CLFontIcon from '../../components/CLFontIcon';

import { getAmenities, selectAmenities, selectAmenitiesLoading } from '../../store/slices/amenities';

import ListingListState from '../../components-shared/ListingListState';

import Item from './Item';
import ItemPlaceholder from './ItemPlaceholder';

import {
  Container,
  List,
  Button,
} from './styled';

const AmenitiesPreview = () => {
  const dispatch = useDispatch();
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const association_id = params.get('association_id');

  const listContainerRef = useRef(null);

  const amenities = useSelector(selectAmenities);
  const isLoading = useSelector(selectAmenitiesLoading);

  const [selected, setSelected] = useState(0);
  const [columns, setColumns] = useState(3);
  const [itemSize, setItemSize] = useState({
    width: 'calc(33% - 21px)',
    height: '240px',
  });

  const isFirst = selected === 0;
  const isLast = selected === amenities.length - columns;

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  }

  const [width, height] = useWindowSize();

  useEffect(() => {
    if (!width || !height) {
      return;
    }

    if (width > 769) {
      setColumns(3);
      setItemSize({
        width: 'calc(33% - 21px)',
        height: '240px',
      });
    }

    if (width < 768) {
      setColumns(2);
      setItemSize({
        width: 'calc(50% - 24px)',
        height: '240px',
      });
    }
    if (width < 560) {
      setColumns(1);
      setItemSize({
        width: 'calc(100% - 24px)',
        height: '240px',
      });
    }
  }, [width, height]);

  useEffect(() => {
    if (!association_id) {
      return;
    }

    dispatch(getAmenities({ association_id }));
  }, [association_id, dispatch]);

  useEffect(() => {
    if (!listContainerRef?.current) {
      return;
    }
    const { current } = listContainerRef;

    current.scrollTo({
      left: ((current.clientWidth / columns) * selected),
      behavior: 'smooth',
    });
  }, [selected, columns]);

  const prev = () => {
    setSelected((index) => (index > 0 ? index - 1 : 0));
  };

  const next = () => {
    const last = amenities.length - columns;
    setSelected((index) => (index < last ? index + 1 : last));
  };

  const onReserve = (item) => {
    const { association: { association_id }, amenity_id, application_url } = item;
    window.open(`${application_url}/amenities/redirect_to?association_id=${association_id}&amenity_id=${amenity_id}`);
  };

  if (isLoading) {
    return (
      <>
        <List>
          {[1, 2, 3, 4].map((item) => <ItemPlaceholder key={item} itemSize={itemSize} />)}
        </List>
      </>
    );
  }

  if (!amenities.length) {
    return <ListingListState type="no_amenities" />;
  }

  return (
    <Container>
      {!isFirst && (
        <Button position="left" onClick={() => prev()}>
          <CLFontIcon icon="caret-left" />
        </Button>
      )}
      {!isLast && (
        <Button position="right" onClick={() => next()}>
          <CLFontIcon icon="caret-right" />
        </Button>
      )}

      <List ref={listContainerRef}>
        {
          amenities.map((item) => <Item key={item.amenity_id} itemSize={itemSize} item={item} onReserve={onReserve} />)
        }
      </List>
    </Container>
  );
};

export default AmenitiesPreview;
